import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FiTrash2, FiX } from 'react-icons/fi';

import { Link as RouterLink, useHistory } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

import WeekSchedules from './WeekSchedules';
import { ModalHandles } from './Modal';

import api from '../../services/api';

import { SHORT_WEEK_DAYS, LONG_WEEK_DAYS } from '../../constants';

import { Container, Wrapper, Content, Modal } from './styles';
import { LoadingContainer } from '../Dashboard/styles';
import ActivityIndicator from '../../components/ActivityIndicator';
import Button from '../../newComponents/Button';
import Axios from 'axios';
import { DeactivationWarning } from './DeactivationWarning';
import { Link } from '@material-ui/core';
import { areIntervalsOverlapping } from 'date-fns';

type WeekDay = {
  start: string;
  end: string;
  delivery?: boolean;
  retirada?: boolean;
};

type Days = {
  seg?: WeekDay[];
  ter?: WeekDay[];
  qua?: WeekDay[];
  qui?: WeekDay[];
  sex?: WeekDay[];
  sab?: WeekDay[];
  dom?: WeekDay[];
};

type WeekDayBeignEdit = {
  shortName: keyof Days;
  name: string;
  start?: string;
  end?: string;
  index: number;
};

const SCHEDULES: string[] = [];

for (let i = 0; i < 24; i += 1) {
  for (let j = 0; j < 60; j += 15) {
    let hours: string | number = i;
    let minutes: string | number = j;

    if (hours < 10) {
      hours = `0${hours}`;
    }

    if (minutes < 10) {
      minutes = `0${minutes}`;
    }

    SCHEDULES.push(`${hours}:${minutes}`);
  }
}

SCHEDULES.push('23:59');

const Schedules: React.FC = () => {
  const addScheduleModalRef = useRef<ModalHandles>(null);
  const customScheduleModalRef = useRef<ModalHandles>(null);
  const editScheduleModalRef = useRef<ModalHandles>(null);

  const { user, rotinas, findRotinas } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();

  const [weekDayBeignEdit, setWeekDayBeignEdit] = useState<WeekDayBeignEdit>({
    name: 'Segunda-feira',
    shortName: 'seg',
    start: '00:00',
    end: '23:00',
    index: 0,
  });
  const [
    deliveryMethodsDayBeingEdit,
    setDeliveryMethodsDayBeingEdit,
  ] = useState({
    delivery: true,
    retirada: true,
  });
  const [loading, setLoading] = useState(false);
  const [days, setDays] = useState<Days | undefined>();
  const [option, setOption] = useState(0);
  const [selectedDays, setSelectedDays] = useState<string[]>(SHORT_WEEK_DAYS);
  const [
    deliveryMethodsSelectedDays,
    setDeliveryMethodsSelectedDays,
  ] = useState({
    delivery: true,
    retirada: true,
  });
  const [selectedDay, setSelectedDay] = useState<string>(SHORT_WEEK_DAYS[0]);
  const [deliveryMethodsSelectedDay, setDeliveryMethodsSelectedDay] = useState({
    delivery: true,
    retirada: true,
  });
  const [startHourCreate, setStartHourCreate] = useState<string>('00:00');
  const [endHourCreate, setEndHourCreate] = useState<string>('23:00');
  const [withdrawEnabled, setWithdrawEnabled] = useState(true);
  const [deliveryEnabled, setDeliveryEnabled] = useState(true);

  useEffect(() => {
    const cancelTokenSource = Axios.CancelToken.source();

    const fetchWithdrawEnabled = async () => {
      const response = await api.get('/parametro', {
        cancelToken: cancelTokenSource.token,
        params: {
          descricao: 'withdraw_enabled',
          empresa_id: user.empresa_id,
        },
      });

      if (response.data) {
        const role = JSON.parse(response.data.role);
        setWithdrawEnabled(role.status);
      } else {
        setWithdrawEnabled(true);
      }
    };

    const fetchDeliveryEnabled = async () => {
      const response = await api.get('/parametro', {
        cancelToken: cancelTokenSource.token,
        params: {
          descricao: 'delivery_enabled',
          empresa_id: user.empresa_id,
        },
      });

      if (response.data) {
        const role = JSON.parse(response.data.role);
        setDeliveryEnabled(role.status);
      } else {
        setDeliveryEnabled(true);
      }
    };

    fetchWithdrawEnabled();
    fetchDeliveryEnabled();

    return () => {
      cancelTokenSource.cancel();
    };
  }, []);

  const handleGetSchedules = useCallback(async () => {
    setLoading(true);

    try {
      const response = await api.get(`/schedules/${user.empresa_id}`);

      if (response.data) {
        setDays(response.data.dias);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);

      addToast({
        title: 'Erro ao tentar obter os horários',
        description: (err as any).response?.data?.message || '',
        type: 'error',
      });
    }
  }, [user.empresa_id, addToast]);

  const handleOpenAddScheduleModal = (): void => {
    addScheduleModalRef.current?.open();
  };

  const handleCloseAddScheduleModal = (): void => {
    addScheduleModalRef.current?.close();
  };

  const handleOpenEditScheduleModal = useCallback(
    (weekDay: keyof Days, index: number): void => {
      const weekDayIndex = SHORT_WEEK_DAYS.findIndex(
        (shortWeekDay) => shortWeekDay === weekDay,
      );

      if (typeof weekDayIndex === 'number' && days) {
        let dayData = days[weekDay]?.find(
          (_, scheduleIndex) => scheduleIndex === index,
        );

        if (!dayData) {
          dayData = { start: '00:00', end: '00:00' };
        }

        setWeekDayBeignEdit({
          ...dayData,
          index,
          shortName: weekDay,
          name: LONG_WEEK_DAYS[weekDayIndex],
        });

        setDeliveryMethodsDayBeingEdit({
          delivery:
            typeof dayData.delivery === 'boolean' ? dayData.delivery : true,
          retirada:
            typeof dayData.retirada === 'boolean' ? dayData.retirada : true,
        });

        return editScheduleModalRef.current?.open();
      }

      return editScheduleModalRef.current?.close();
    },
    [days],
  );

  const handleCloseEditScheduleModal = useCallback((): void => {
    editScheduleModalRef.current?.close();
  }, []);

  const handleOpenCustomScheduleModal = (): void => {
    customScheduleModalRef.current?.open();
  };

  const handleCloseCustomScheduleModal = useCallback((): void => {
    customScheduleModalRef.current?.close();
  }, []);

  const handleCreateSchedules = useCallback(async (): Promise<void> => {
    const starDate = new Date(`2021-01-01T${startHourCreate}:00`);
    const endDate = new Date(`2021-01-01T${endHourCreate}:00`);

    if (!checkScheduleAvailability(selectedDays)) {
      return;
    }

    if (starDate >= endDate) {
      return addToast({
        title: 'Erro ao tentar criar os horários',
        description: 'A data de início tem que ser menor do que a data final',
        type: 'error',
      });
    }

    if (selectedDays.length === 0) {
      return addToast({
        title: 'Erro ao tentar criar os horários',
        description: 'Selecione pelo menos um dia',
        type: 'error',
      });
    }

    try {
      setLoading(true);
      handleCloseAddScheduleModal();

      const parsedDays = {};

      SHORT_WEEK_DAYS.filter((weekDay) =>
        selectedDays.includes(weekDay),
      ).forEach((weekDay) => {
        Object.assign(parsedDays, {
          [weekDay]: [
            {
              start: startHourCreate,
              end: endHourCreate,
              delivery: deliveryMethodsSelectedDays.delivery,
              retirada: deliveryMethodsSelectedDays.retirada,
            },
          ],
        });
      });

      if (days) {
        const response = await api.put('/schedules', {
          days: parsedDays,
          active: true,
        });

        setDays(response.data.dias);

        return setLoading(false);
      }

      const response = await api.post('/schedules', {
        days: parsedDays,
        active: true,
      });

      setDays(response.data.dias);
      setLoading(false);
    } catch (err) {
      setLoading(false);

      addToast({
        title: 'Erro ao tentar criar os horários',
        description: (err as any).response?.data?.message || '',
        type: 'error',
      });
    }

    return setLoading(false);
  }, [
    days,
    selectedDays,
    startHourCreate,
    endHourCreate,
    addToast,
    deliveryMethodsSelectedDays,
  ]);

  const handleEditSchedule = useCallback(
    async (isDelete?: boolean): Promise<void> => {
      if (!editScheduleAvailability(weekDayBeignEdit)) {
        return;
      }

      if (!isDelete) {
        const starDate = new Date(`2021-01-01T${weekDayBeignEdit.start}:00`);
        const endDate = new Date(`2021-01-01T${weekDayBeignEdit.end}:00`);

        if (starDate >= endDate) {
          return addToast({
            title: 'Erro ao tentar editar os horários',
            description:
              'A data de início tem que ser menor do que a data final',
            type: 'error',
          });
        }
      }

      try {
        setLoading(true);
        handleCloseEditScheduleModal();

        const parsedDays = days || {};

        if (isDelete) {
          if (parsedDays[weekDayBeignEdit.shortName]) {
            if (parsedDays[weekDayBeignEdit.shortName]?.length === 1) {
              delete parsedDays[weekDayBeignEdit.shortName];
            } else {
              Object.assign(parsedDays, {
                [weekDayBeignEdit.shortName]: parsedDays[
                  weekDayBeignEdit.shortName
                ]?.filter(
                  (_, scheduleIndex) =>
                    scheduleIndex !== weekDayBeignEdit.index,
                ),
              });
            }
          }

          const response = await api.put('/schedules', {
            days: parsedDays,
            active: true,
          });

          setDays(response.data.dias);

          return setLoading(false);
        }

        const restParsedDays = parsedDays[weekDayBeignEdit.shortName] || [];

        Object.assign(parsedDays, {
          [weekDayBeignEdit.shortName]: restParsedDays.map(
            (schedule, index) => {
              if (index === weekDayBeignEdit.index) {
                return {
                  start: weekDayBeignEdit.start,
                  end: weekDayBeignEdit.end,
                  delivery: deliveryMethodsDayBeingEdit.delivery,
                  retirada: deliveryMethodsDayBeingEdit.retirada,
                };
              }

              return schedule;
            },
          ),
        });

        const response = await api.put('/schedules', {
          days: parsedDays,
          active: true,
        });
        setDays(response.data.dias);

        return setLoading(false);
      } catch (err) {
        addToast({
          title: 'Erro ao tentar editar os horários',
          description: (err as any).response?.data?.message || '',
          type: 'error',
        });
      }

      return setLoading(false);
    },
    [
      days,
      weekDayBeignEdit,
      addToast,
      handleCloseEditScheduleModal,
      deliveryMethodsDayBeingEdit,
    ],
  );

  const handleAddSchedule = useCallback(async () => {
    const starDate = new Date(`2021-01-01T${startHourCreate}:00`);
    const endDate = new Date(`2021-01-01T${endHourCreate}:00`);

    if (!checkScheduleAvailability([selectedDay])) {
      return;
    }

    if (starDate >= endDate) {
      return addToast({
        title: 'Erro ao tentar criar os horários',
        description: 'A data de início tem que ser menor do que a data final',
        type: 'error',
      });
    }

    try {
      setLoading(true);
      handleCloseCustomScheduleModal();

      const parsedDays = days || {};

      const restParsedDays = parsedDays[selectedDay as keyof Days] || [];

      Object.assign(parsedDays, {
        [selectedDay]: [
          ...restParsedDays,
          {
            start: startHourCreate,
            end: endHourCreate,
            delivery: deliveryMethodsSelectedDay.delivery,
            retirada: deliveryMethodsSelectedDay.retirada,
          },
        ],
      });

      const response = await api.put('/schedules', {
        days: parsedDays,
        active: true,
      });

      setDays(response.data.dias);

      return setLoading(false);
    } catch (err) {
      setLoading(false);

      addToast({
        title: 'Erro ao tentar criar os horários',
        description: (err as any).response?.data?.message || '',
        type: 'error',
      });
    }

    return setLoading(false);
  }, [
    days,
    selectedDay,
    startHourCreate,
    endHourCreate,
    addToast,
    handleCloseCustomScheduleModal,
    deliveryMethodsSelectedDay,
  ]);

  const handleDeleteCustomSchedule = useCallback(
    async (index: number) => {
      try {
        setLoading(true);
        handleCloseCustomScheduleModal();

        const parsedDays = days || {};

        if (parsedDays[selectedDay as keyof Days]) {
          if (parsedDays[selectedDay as keyof Days]?.length === 1) {
            delete parsedDays[selectedDay as keyof Days];
          } else {
            Object.assign(parsedDays, {
              [selectedDay]: parsedDays[selectedDay as keyof Days]?.filter(
                (_, scheduleIndex) => scheduleIndex !== index,
              ),
            });
          }
        }

        const response = await api.put('/schedules', {
          days: parsedDays,
          active: true,
        });

        setDays(response.data.dias);

        return setLoading(false);
      } catch (err) {
        setLoading(false);

        addToast({
          title: 'Erro ao tentar excluir o horário',
          description: (err as any).response?.data?.message || '',
          type: 'error',
        });
      }

      return setLoading(false);
    },
    [days, selectedDay, addToast, handleCloseCustomScheduleModal],
  );

  const hasPermission = useCallback(
    (): boolean => findRotinas('horarios')?.listar || false,
    [findRotinas],
  );

  useEffect(() => {
    if (rotinas && !hasPermission()) {
      addToast({
        type: 'error',
        title: 'Não autorizado.',
        description: 'Você não tem permissão.',
      });
      history.push('/monitor_pedidos');
    }
  }, [addToast, hasPermission, history, rotinas]);

  useEffect(() => {
    handleGetSchedules();
  }, [handleGetSchedules]);

  function checkScheduleAvailability(selectedDaysToTest: string[]) {
    if (days) {
      const dayWithOverlappingInterval = selectedDaysToTest.find(
        (day) =>
          !!days[day as keyof Days]?.find((interval) => {
            return areIntervalsOverlapping(
              {
                start: new Date(`2021-01-01T${startHourCreate}:00`),
                end: new Date(`2021-01-01T${endHourCreate}:00`),
              },
              {
                start: new Date(`2021-01-01T${interval.start}:00`),
                end: new Date(`2021-01-01T${interval.end}:00`),
              },
            );
          }),
      );

      if (dayWithOverlappingInterval) {
        const intervalOverlapping = days[
          dayWithOverlappingInterval as keyof Days
        ]?.find((interval) => {
          return areIntervalsOverlapping(
            {
              start: new Date(`2021-01-01T${startHourCreate}:00`),
              end: new Date(`2021-01-01T${endHourCreate}:00`),
            },
            {
              start: new Date(`2021-01-01T${interval.start}:00`),
              end: new Date(`2021-01-01T${interval.end}:00`),
            },
          );
        });

        if (intervalOverlapping) {
          const shortNameIndex = SHORT_WEEK_DAYS.findIndex(
            (shortWeekDay) =>
              shortWeekDay.localeCompare(dayWithOverlappingInterval) === 0,
          );
          addToast({
            title: 'Erro ao tentar criar os horários',
            description: `O horário está em conflito com ${LONG_WEEK_DAYS[shortNameIndex]}: ${intervalOverlapping.start} - ${intervalOverlapping.end}`,
            type: 'error',
          });
        }
        return false;
      }
    }

    return true;
  }

  function editScheduleAvailability(dayBeingEdited: WeekDayBeignEdit) {
    if (days) {
      const intervalOverlapping = days[
        dayBeingEdited.shortName as keyof Days
      ]?.find((interval, index) => {
        return (index !== dayBeingEdited.index) && areIntervalsOverlapping(
          {
            start: new Date(`2021-01-01T${dayBeingEdited.start}:00`),
            end: new Date(`2021-01-01T${dayBeingEdited.end}:00`),
          },
          {
            start: new Date(`2021-01-01T${interval.start}:00`),
            end: new Date(`2021-01-01T${interval.end}:00`),
          },
        );
      });

      if (intervalOverlapping) {
        addToast({
          title: 'Erro ao tentar criar os horários',
          description: `O horário está em conflito com ${dayBeingEdited.name}: ${intervalOverlapping.start} - ${intervalOverlapping.end}`,
          type: 'error',
        });

        return false;
      }
    }

    return true;
  }

  return (
    <Container>
      <Wrapper>
        <header>
          <div>
            <h1>Horário de funcionamento</h1>
            <h3>Escolha os horários que sua loja abrirá</h3>
            {!withdrawEnabled && (
              <DeactivationWarning
                text="Retirada desativada"
                description="A retirada foi desativada e não aparecerá como opção para os clientes"
              />
            )}
            {!deliveryEnabled && (
              <DeactivationWarning
                text="Delivery desativado"
                description="O delivery foi desativado e não aparecerá como opção para os clientes"
              />
            )}
            <Link
              component={RouterLink}
              to="configuracoes/8/4"
              style={{
                display: 'block',
                marginTop: '0.5rem',
                textDecoration: 'underline',
              }}
            >
              Configurações de entrega
            </Link>
          </div>
          <div style={{ display: 'flex' }}>
            <Button
              onClick={handleOpenAddScheduleModal}
              disabled={!hasPermission()}
            >
              <span>Adicionar horário</span>
            </Button>
            <Button
              type="button"
              className="outline"
              onClick={handleOpenCustomScheduleModal}
              disabled={!hasPermission()}
            >
              <span>Horário personalizado</span>
            </Button>
          </div>
        </header>
        <Content>
          {loading ? (
            <LoadingContainer>
              <ActivityIndicator />
            </LoadingContainer>
          ) : (
            <>
              <div className="hours">
                {Array(13)
                  .fill('')
                  .map((_, hour) => (
                    <span key={hour}>{hour * 2}h</span>
                  ))}
              </div>
              <div className="week-days">
                <WeekSchedules
                  days={days}
                  onEditSchedule={handleOpenEditScheduleModal}
                />
              </div>
            </>
          )}
        </Content>
      </Wrapper>
      <Modal ref={addScheduleModalRef}>
        <header>
          <h3>Escolha os dias e horários</h3>
          <button type="button" onClick={handleCloseAddScheduleModal}>
            <FiX />
          </button>
        </header>
        <main>
          <div className="week-days">
            <div className="week-day">
              <label htmlFor="seg">Seg</label>
              <input
                type="checkbox"
                id="seg"
                name="seg"
                checked={selectedDays.includes('seg')}
                onChange={(event) =>
                  event.target.checked
                    ? setSelectedDays((oldState) => [...oldState, 'seg'])
                    : setSelectedDays((oldState) =>
                        oldState.filter((weekDay) => weekDay !== 'seg'),
                      )
                }
              />
            </div>
            <div className="week-day">
              <label htmlFor="ter">Ter</label>
              <input
                type="checkbox"
                id="ter"
                name="ter"
                checked={selectedDays.includes('ter')}
                onChange={(event) =>
                  event.target.checked
                    ? setSelectedDays((oldState) => [...oldState, 'ter'])
                    : setSelectedDays((oldState) =>
                        oldState.filter((weekDay) => weekDay !== 'ter'),
                      )
                }
              />
            </div>
            <div className="week-day">
              <label htmlFor="qua">Qua</label>
              <input
                type="checkbox"
                id="qua"
                name="qua"
                checked={selectedDays.includes('qua')}
                onChange={(event) =>
                  event.target.checked
                    ? setSelectedDays((oldState) => [...oldState, 'qua'])
                    : setSelectedDays((oldState) =>
                        oldState.filter((weekDay) => weekDay !== 'qua'),
                      )
                }
              />
            </div>
            <div className="week-day">
              <label htmlFor="qui">Qui</label>
              <input
                type="checkbox"
                id="qui"
                name="qui"
                checked={selectedDays.includes('qui')}
                onChange={(event) =>
                  event.target.checked
                    ? setSelectedDays((oldState) => [...oldState, 'qui'])
                    : setSelectedDays((oldState) =>
                        oldState.filter((weekDay) => weekDay !== 'qui'),
                      )
                }
              />
            </div>
            <div className="week-day">
              <label htmlFor="sex">Sex</label>
              <input
                type="checkbox"
                id="sex"
                name="sex"
                checked={selectedDays.includes('sex')}
                onChange={(event) =>
                  event.target.checked
                    ? setSelectedDays((oldState) => [...oldState, 'sex'])
                    : setSelectedDays((oldState) =>
                        oldState.filter((weekDay) => weekDay !== 'sex'),
                      )
                }
              />
            </div>
            <div className="week-day">
              <label htmlFor="sab">Sab</label>
              <input
                type="checkbox"
                id="sab"
                name="sab"
                checked={selectedDays.includes('sab')}
                onChange={(event) =>
                  event.target.checked
                    ? setSelectedDays((oldState) => [...oldState, 'sab'])
                    : setSelectedDays((oldState) =>
                        oldState.filter((weekDay) => weekDay !== 'sab'),
                      )
                }
              />
            </div>
            <div className="week-day">
              <label htmlFor="dom">Dom</label>
              <input
                type="checkbox"
                id="dom"
                name="dom"
                checked={selectedDays.includes('dom')}
                onChange={(event) =>
                  event.target.checked
                    ? setSelectedDays((oldState) => [...oldState, 'dom'])
                    : setSelectedDays((oldState) =>
                        oldState.filter((weekDay) => weekDay !== 'dom'),
                      )
                }
              />
            </div>
          </div>
          <div className="options">
            <div className="option">
              <input
                type="radio"
                name="hours"
                id="custom-hours"
                checked={option === 0}
                onChange={() => setOption(0)}
              />
              <label htmlFor="custom-hours">
                Das{' '}
                <select
                  disabled={option !== 0}
                  value={startHourCreate}
                  onChange={(event) => setStartHourCreate(event.target.value)}
                >
                  {SCHEDULES.map((schedule) => (
                    <option key={schedule}>{schedule}</option>
                  ))}
                </select>{' '}
                Até{' '}
                <select
                  disabled={option !== 0}
                  value={endHourCreate}
                  onChange={(event) => setEndHourCreate(event.target.value)}
                >
                  {SCHEDULES.map((schedule) => (
                    <option key={schedule}>{schedule}</option>
                  ))}
                </select>
              </label>
            </div>
            <div className="option">
              <input
                type="radio"
                name="hours"
                id="business-hours"
                checked={option === 1}
                onChange={() => {
                  setOption(1);
                  setStartHourCreate('08:00');
                  setEndHourCreate('18:00');
                }}
              />
              <label htmlFor="business-hours">
                Usar horário comercial (08:00 às 18:00)
              </label>
            </div>
            <div className="option">
              <input
                type="radio"
                name="hours"
                id="extended-business-hours"
                checked={option === 2}
                onChange={() => {
                  setOption(2);
                  setStartHourCreate('10:00');
                  setEndHourCreate('22:00');
                }}
              />
              <label htmlFor="extended-business-hours">
                Usar horário comercial estendido (10:00 às 22:00)
              </label>
            </div>
            <div className="delivery-methods">
              <div>
                <input
                  type="checkbox"
                  id="enable-delivery"
                  name="enable-delivery"
                  checked={deliveryMethodsSelectedDays.delivery}
                  onChange={(event) =>
                    event.target.checked
                      ? setDeliveryMethodsSelectedDays((state) => ({
                          ...state,
                          delivery: true,
                        }))
                      : setDeliveryMethodsSelectedDays((state) => ({
                          ...state,
                          delivery: false,
                        }))
                  }
                  disabled={!deliveryMethodsSelectedDays.retirada}
                />
                <label htmlFor="enable-delivery">Delivery</label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="enable-withdraw"
                  name="enable-withdraw"
                  checked={deliveryMethodsSelectedDays.retirada}
                  onChange={(event) =>
                    event.target.checked
                      ? setDeliveryMethodsSelectedDays((state) => ({
                          ...state,
                          retirada: true,
                        }))
                      : setDeliveryMethodsSelectedDays((state) => ({
                          ...state,
                          retirada: false,
                        }))
                  }
                  disabled={!deliveryMethodsSelectedDays.delivery}
                />
                <label htmlFor="enable-withdraw">Retirada</label>
              </div>
            </div>
          </div>
        </main>
        <footer>
          <button
            className="outline"
            type="button"
            onClick={handleCloseAddScheduleModal}
          >
            <span>Cancelar</span>
          </button>
          <button
            className="default"
            type="button"
            onClick={handleCreateSchedules}
          >
            <span>Adicionar</span>
          </button>
        </footer>
      </Modal>
      <Modal ref={customScheduleModalRef}>
        <header>
          <h3>Escolha um dia e os horários</h3>
          <button type="button" onClick={handleCloseCustomScheduleModal}>
            <FiX />
          </button>
        </header>
        <main>
          <div className="week-days">
            <div className="week-day">
              <label htmlFor="seg">Seg</label>
              <input
                type="radio"
                id="seg"
                name="selected-day"
                checked={selectedDay === 'seg'}
                onChange={() => setSelectedDay('seg')}
              />
            </div>
            <div className="week-day">
              <label htmlFor="ter">Ter</label>
              <input
                type="radio"
                id="ter"
                name="selected-day"
                checked={selectedDay === 'ter'}
                onChange={() => setSelectedDay('ter')}
              />
            </div>
            <div className="week-day">
              <label htmlFor="qua">Qua</label>
              <input
                type="radio"
                id="qua"
                name="selected-day"
                checked={selectedDay === 'qua'}
                onChange={() => setSelectedDay('qua')}
              />
            </div>
            <div className="week-day">
              <label htmlFor="qui">Qui</label>
              <input
                type="radio"
                id="qui"
                name="selected-day"
                checked={selectedDay === 'qui'}
                onChange={() => setSelectedDay('qui')}
              />
            </div>
            <div className="week-day">
              <label htmlFor="sex">Sex</label>
              <input
                type="radio"
                id="sex"
                name="selected-day"
                checked={selectedDay === 'sex'}
                onChange={() => setSelectedDay('sex')}
              />
            </div>
            <div className="week-day">
              <label htmlFor="sab">Sab</label>
              <input
                type="radio"
                id="sab"
                name="selected-day"
                checked={selectedDay === 'sab'}
                onChange={() => setSelectedDay('sab')}
              />
            </div>
            <div className="week-day">
              <label htmlFor="dom">Dom</label>
              <input
                type="radio"
                id="dom"
                name="selected-day"
                checked={selectedDay === 'dom'}
                onChange={() => setSelectedDay('dom')}
              />
            </div>
          </div>
          <div
            className="options"
            style={{
              display: 'flex',
              flexDirection: 'column',
              borderBottom: '1px solid #E6EFFB',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div className="option">
                Das
                <select
                  disabled={option !== 0}
                  value={startHourCreate}
                  onChange={(event) => setStartHourCreate(event.target.value)}
                  style={{ marginLeft: 5, marginRight: 5 }}
                >
                  {SCHEDULES.map((schedule) => (
                    <option key={schedule}>{schedule}</option>
                  ))}
                </select>{' '}
                Até{' '}
                <select
                  disabled={option !== 0}
                  value={endHourCreate}
                  onChange={(event) => setEndHourCreate(event.target.value)}
                  style={{ marginLeft: 5 }}
                >
                  {SCHEDULES.map((schedule) => (
                    <option key={schedule}>{schedule}</option>
                  ))}
                </select>
              </div>

              <button
                className="default"
                type="button"
                onClick={handleAddSchedule}
              >
                <span>Adicionar</span>
              </button>
            </div>
            <div className="delivery-methods">
              <div>
                <input
                  type="checkbox"
                  id="enable-delivery"
                  name="enable-delivery"
                  checked={deliveryMethodsSelectedDay.delivery}
                  onChange={(event) =>
                    event.target.checked
                      ? setDeliveryMethodsSelectedDay((state) => ({
                          ...state,
                          delivery: true,
                        }))
                      : setDeliveryMethodsSelectedDay((state) => ({
                          ...state,
                          delivery: false,
                        }))
                  }
                  disabled={!deliveryMethodsSelectedDay.retirada}
                />
                <label htmlFor="enable-delivery">Delivery</label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="enable-withdraw"
                  name="enable-withdraw"
                  checked={deliveryMethodsSelectedDay.retirada}
                  onChange={(event) =>
                    event.target.checked
                      ? setDeliveryMethodsSelectedDay((state) => ({
                          ...state,
                          retirada: true,
                        }))
                      : setDeliveryMethodsSelectedDay((state) => ({
                          ...state,
                          retirada: false,
                        }))
                  }
                  disabled={!deliveryMethodsSelectedDay.delivery}
                />
                <label htmlFor="enable-withdraw">Retirada</label>
              </div>
            </div>
          </div>

          <div className="schedules-weekday">
            {days &&
              days[selectedDay as keyof Days]?.map((schedule, index) => (
                <div key={Math.random()}>
                  <span>
                    Das <strong>{schedule.start}</strong> até{' '}
                    <strong>{schedule.end}</strong>
                  </span>
                  <button
                    type="button"
                    className="delete"
                    onClick={() => handleDeleteCustomSchedule(index)}
                  >
                    <FiTrash2 />
                  </button>
                </div>
              ))}
          </div>
        </main>
      </Modal>
      <Modal ref={editScheduleModalRef}>
        <header>
          <h3>
            {weekDayBeignEdit.name} - {weekDayBeignEdit.start}-
            {weekDayBeignEdit.end}
          </h3>
          <button type="button" onClick={handleCloseEditScheduleModal}>
            <FiX />
          </button>
        </header>
        <main>
          <div className="edit-schedule">
            <span>Das</span>
            <select
              value={weekDayBeignEdit.start}
              onChange={(event) => {
                event.persist();

                setWeekDayBeignEdit((oldState) => ({
                  ...oldState,
                  start: event.target.value,
                }));
              }}
            >
              {SCHEDULES.map((schedule) => (
                <option key={schedule} value={schedule}>
                  {schedule}
                </option>
              ))}
            </select>
            <span>Até</span>
            <select
              value={weekDayBeignEdit.end}
              onChange={(event) => {
                event.persist();

                setWeekDayBeignEdit((oldState) => ({
                  ...oldState,
                  end: event.target.value,
                }));
              }}
            >
              {SCHEDULES.map((schedule) => (
                <option key={schedule} value={schedule}>
                  {schedule}
                </option>
              ))}
            </select>
            <button
              type="button"
              className="delete"
              onClick={() => handleEditSchedule(true)}
            >
              <FiTrash2 />
            </button>
          </div>
          <div className="delivery-methods">
            <div>
              <input
                type="checkbox"
                id="enable-delivery"
                name="enable-delivery"
                checked={deliveryMethodsDayBeingEdit.delivery}
                onChange={(event) => {
                  event.target.checked
                    ? setDeliveryMethodsDayBeingEdit((state) => ({
                        ...state,
                        delivery: true,
                      }))
                    : setDeliveryMethodsDayBeingEdit((state) => ({
                        ...state,
                        delivery: false,
                      }));
                }}
                disabled={!deliveryMethodsDayBeingEdit.retirada}
              />
              <label htmlFor="enable-delivery">Delivery</label>
            </div>
            <div>
              <input
                type="checkbox"
                id="enable-withdraw"
                name="enable-withdraw"
                checked={deliveryMethodsDayBeingEdit.retirada}
                onChange={(event) =>
                  event.target.checked
                    ? setDeliveryMethodsDayBeingEdit((state) => ({
                        ...state,
                        retirada: true,
                      }))
                    : setDeliveryMethodsDayBeingEdit((state) => ({
                        ...state,
                        retirada: false,
                      }))
                }
                disabled={!deliveryMethodsDayBeingEdit.delivery}
              />
              <label htmlFor="enable-withdraw">Retirada</label>
            </div>
          </div>
        </main>
        <footer>
          <button
            className="outline"
            type="button"
            onClick={handleCloseEditScheduleModal}
          >
            <span>Cancelar</span>
          </button>
          <button
            className="default"
            type="button"
            onClick={() => handleEditSchedule(false)}
          >
            <span>Editar</span>
          </button>
        </footer>
      </Modal>
    </Container>
  );
};

export default Schedules;
